/**
 * Assessment Provider component
 */

import type { ReactNode } from "react";
import { useAssessment } from "../hooks/useAssessment";
import { AssessmentContext } from "./assessmentContextDef";

export function AssessmentProvider({ children }: { children: ReactNode }) {
  const assessment = useAssessment();

  return (
    <AssessmentContext.Provider value={assessment}>
      {children}
    </AssessmentContext.Provider>
  );
}
